"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageExporter = void 0;
var tslib_1 = require("tslib");
var extension_helper_1 = require("../../../../core/formats/utils/extension-helper");
var base_1 = require("../base");
var ImageExporter = (function (_super) {
    tslib_1.__extends(ImageExporter, _super);
    function ImageExporter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageExporter.prototype.exportImageData = function (modelImageId, base64Uri) {
        var isRelationExported = this.data.exportedImageTable[modelImageId];
        this.data.exportedImageTable[modelImageId] = true;
        var contentType = extension_helper_1.ExtensionHelper.getMimeTypeFromBase64Uri(base64Uri);
        var extension = extension_helper_1.ExtensionHelper.convertMimeTypeToExtension(contentType);
        this.data.contentTypesExporter.registerContentType(extension, contentType);
        var imageName = this.data.idGenerator.generateImageName(modelImageId);
        if (!isRelationExported)
            this.data.zipBuilder.addBase64("word/media/" + imageName + "." + extension, extension_helper_1.ExtensionHelper.getBase64DataWithoutPrefix(base64Uri));
        var imageRelationId = this.data.idGenerator.generateImageRelationId(modelImageId);
        this.data.relationExporter.imageRelationsTable[imageRelationId] = "media/" + imageName + "." + extension;
        return imageRelationId;
    };
    ImageExporter.prototype.exportImageUrl = function (modelImageId, url) {
        var imageRelationId = this.data.idGenerator.generateImageRelationId(modelImageId);
        this.data.relationExporter.exportedExternalImageRelationsTable[imageRelationId] = url;
        return imageRelationId;
    };
    return ImageExporter;
}(base_1.BaseExporter));
exports.ImageExporter = ImageExporter;
